/**
 * The edition band (ADR 0035): the 232 x 88 cover beside the eyebrow, the
 * page `h1` and one meta line, with at most one quiet act at the right end.
 * The band is identity and navigation; the page's filled act lives in the
 * tile that owns the object it changes. One band per surface, exactly one
 * `h1`; for a class the code is the course and the title is the class.
 * The band is the frame, never a box (CASE-006).
 */
import type { ReactNode } from "react";

import { frameHook } from "@/components/ui/box.schema";
import { EditionCover } from "@/components/workspace/EditionCover";
import { FrameTitle } from "@/components/workspace/FrameHeader";
import { cn } from "@/lib/utils";

export function EditionBand({
  code,
  label,
  eyebrow,
  title,
  meta,
  action,
  className,
}: {
  code: string;
  /** The department name when the payload carries one; never invented. */
  label?: string | null;
  eyebrow?: ReactNode;
  title: ReactNode;
  meta?: ReactNode;
  /** At most one quiet act. */
  action?: ReactNode;
  className?: string;
}) {
  return (
    <header data-slot="page-frame" data-edition-band {...frameHook("band")} className={cn("flex min-w-0 flex-wrap items-center gap-x-5 gap-y-3", className)}>
      <EditionCover code={code} label={label} variant="band" />
      <FrameTitle eyebrow={eyebrow} title={title} meta={meta} />
      {action && <div className="flex shrink-0 items-center">{action}</div>}
    </header>
  );
}
